import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  separator: {
    flex: 1,
    [theme.media.mobile]: {
      display: 'none',
    },
  },
}));

export const NavbarSpacer = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return <div className={classes.separator} />;
};
